export default "__VITE_PUBLIC_ASSET__eb762159__"